// SurfRing — the progress ring used across the Get-Live surfaces (launcher,
// companion campaign rows, celebration). Cyan while incomplete, green at 100%.
// Stroke animates via stroke-dashoffset, gated behind prefers-reduced-motion.
import React from 'react';

export default function SurfRing({ size = 44, stroke = 4, pct = 0, color, track = '#e3eaf1', children }) {
  const clamped = Math.max(0, Math.min(1, pct));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c * (1 - clamped);
  const ringColor = color || (clamped >= 1 ? '#16a34a' : '#0891b2');
  return (
    <div className="relative flex-none" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="block -rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={track} strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={ringColor} strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          className="motion-safe:transition-[stroke-dashoffset,stroke] motion-safe:duration-500 motion-safe:ease-out"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">{children}</div>
    </div>
  );
}

// The Surf fox avatar chip (dark slate tile, cyan-edged), used as "Surf" the narrator.
export function SurfAvatar({ size = 38, radius = 11, ring = false }) {
  return (
    <div
      className="flex-none flex items-center justify-center overflow-hidden border border-surfox-cyan400/35"
      style={{
        width: size, height: size, borderRadius: radius,
        background: 'linear-gradient(155deg,#152133,#0b1220)',
        boxShadow: ring ? '0 0 0 4px rgba(34,211,238,0.14)' : '0 1px 2px rgba(8,18,32,0.4)',
      }}
    >
      <img src="/logo.png" alt="Surf" className="object-contain" style={{ width: '78%', height: '78%' }} />
    </div>
  );
}
